import React from 'react';
import styles from './AboutSection.module.css';
// import { FaDrone } from 'react-icons/fa';

const AboutSection = () => {
  // Image paths - using public folder paths
  const imagePaths = {
    droneFieldImage: '/Assets/Images/About/DroneFlyingOne.svg',
    droneOceanImage: '/Assets/Images/About/DroneFlyingTwo.svg',
    designItHere: '/Assets/Images/About/DesignItHere.svg',
    makeItHere: '/Assets/Images/About/makeItHere.svg',
    supportFromHere: '/Assets/Images/About/supportFromHere.svg'
  };

  return (
    <div className={styles.outer_area}>
    <div className={styles.aboutContainer}>
      <div className={styles.titleWrapper}>
        <h1 className={styles.title}>About</h1>
        <p className={styles.subtitle}>axldrone - Defining the Future of Industrial Aerial Innovation</p>
      </div>
      
      <p className={styles.text}>
        For over 10 years, we have been a trusted leader in technology solutions, specializing in 
        integrations and automations across diverse industries and businesses worldwide. Our 
        deep expertise in optimizing operations through smart software solutions—combined with 
        invaluable insights from our customers—led us to expand into advanced hardware 
        electronics. Today, we design and manufacture state-of-the-art RFID systems, high-precision 
        GPS devices, drones, remote controls, and IoT solutions, delivering seamless 
        connectivity and immense possibilities. Our journey is driven by a commitment to 
        excellence, reliability, and future-ready technology, empowering businesses to work 
        smarter, faster, and more efficiently.
      </p>
      
      <img 
        src={imagePaths.droneFieldImage} 
        alt="Drone flying over field" 
        className={styles.image}
        loading="lazy"
      />
      
      <p className={styles.text}>
        At the forefront of industrial drone technology, axldrone sets the standard with purpose-built 
        aerial platforms, state-of-the-art avionics, and intelligent ground control solutions. 
        Backed by over a decade of global R&D and mission-proven expertise, every system reflects 
        our unwavering commitment to performance, reliability, and innovation. From design to 
        deployment, axldrone delivers elite, end-to-end drone solutions tailored for the world's most 
        demanding industrial operations.
      </p>
      
      <img 
        src={imagePaths.droneOceanImage} 
        alt="Drone flying over ocean" 
        className={styles.image}
        loading="lazy"
      />
      
      <p className={styles.text}>
        We don't just build drones — we engineer the entire ecosystem. From GPS modules and 
        remote controllers to our own operating system and integrated platform, we design and 
        develop every layer of the technology stack. This holistic approach enables us to unlock 
        endless possibilities and deliver seamless performance across diverse applications.
      </p>
    </div>
      <div className={styles["custom-flex"]}>
        <div className={styles["row full-width"]}>
          <img src={imagePaths.designItHere} alt="Design" className={styles["map-image"]} />
        </div>

        <div className={styles["row two-columns"]}>
          <div className={styles["column"]}>axldrone Headquarters</div>
          <div className={styles["column"]}>Kochi, Kerala</div>
        </div>
      </div>
      <div className={styles["custom-flex"]}>
        <div className={styles["row full-width"]}>
          <img src={imagePaths.makeItHere} alt="Design" className={styles["map-image"]} />
        </div>

        <div className={styles["row two-columns"]}>
          <div className={styles["column-right"]}>axldrone Headquarters</div>
          <div className={styles["column-right"]}>Kochi, Kerala</div>
        </div>
      </div>
      
      <div className={styles["custom-flex"]}>
        <div className={styles["row full-width"]}>
          <img src={imagePaths.supportFromHere} alt="Design" className={styles["map-image" ]}/>
        </div>

        <div className={styles["row two-columns"]}>
          <div className={styles["column"]}>axldrone Headquarters</div>
          <div className={styles["column"]}>Kochi, Kerala</div>
        </div>
      </div>
    
    </div>
  );
};

export default AboutSection;